import MessageBox from './src/main.js';
export default MessageBox;



// WEBPACK FOOTER //
// ./src/components/common/element-ui/packages/message-box/index.js